import { getAllowedRoles } from './models/security-roles';

export interface SidenavLink {
  url: string;
  icon: string;
  label: string;
  securityRoles: string[];
}

// Central list of navigation links used for the sidenav and initial redirect logic.
export const SidenavLinks: SidenavLink[] = [
  {
    url: '/system',
    icon: 'security',
    label: 'System',
    securityRoles: getAllowedRoles('/system'),
  },
  {
    url: '/payroll',
    icon: 'account_balance',
    label: 'Payroll',
    securityRoles: getAllowedRoles('/payroll'),
  },
  {
    url: '/compensation',
    icon: 'monetization_on',
    label: 'Compensation',
    securityRoles: getAllowedRoles('/compensation'),
  },
  {
    url: '/talent-management',
    icon: 'people',
    label: 'Talent Management',
    securityRoles: getAllowedRoles('/talent-management'),
  },
  {
    url: '/learning',
    icon: 'school',
    label: 'Learning',
    securityRoles: getAllowedRoles('/learning'),
  },
  {
    url: '/workday',
    icon: 'school',
    label: 'Workday',
    securityRoles: getAllowedRoles('/workday'),
  },
  {
    url: '/people-data',
    icon: 'school',
    label: 'People Data',
    securityRoles: getAllowedRoles('/people-data'),
  },
];
